export default __webpack_public_path__ + "static/media/house.10f7b000.svg";